const setItem = (key, value) => {
  let existingConfig = localStorage.getItem('d76d36d8b3dd9d4e6c87b6b4e6ce4ef3');
  existingConfig = existingConfig ? JSON.parse(existingConfig) : {};
  existingConfig[key] = value;
  localStorage.setItem(
    'd76d36d8b3dd9d4e6c87b6b4e6ce4ef3',
    JSON.stringify(existingConfig)
  );
};

const getItem = (key) => {
  let existingConfig = localStorage.getItem('d76d36d8b3dd9d4e6c87b6b4e6ce4ef3');
  existingConfig = existingConfig ? JSON.parse(existingConfig) : {};
  return existingConfig[key];
};

const setAddress = (address) => setItem('address', address);
const setToken = (token) => setItem('token', token);
const setMMToken = (token) => setItem('mmToken', token);

const getAddress = () => getItem('address');
const getToken = () => getItem('token');
const getMMToken = () => getItem('mmToken');

const enablePepe = () => setItem('pepe', '🖕');
const isPepeEnabled = () => getItem('pepe') === '🖕';

const clear = () => {
  localStorage.setItem('d76d36d8b3dd9d4e6c87b6b4e6ce4ef3', JSON.stringify({}));
};

export default {
  setAddress,
  setToken,
  setMMToken,
  getAddress,
  getToken,
  getMMToken,
  clear,
  enablePepe,
  isPepeEnabled
};
